export default __webpack_public_path__ + "fonts/0350e2932fca6876618383592b00d501.woff";